import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfAppAveragesSummaryRequestDto } from '../../dtos/scores/get-self-app-averages-summary.request.dto';
import { GetSelfAppAveragesSummaryResponseDto } from '../../dtos/scores/get-self-app-averages-summary.response.dto';
import { GetSelfAppAveragesSummaryPresenter } from '../../presenters/scores/get-self-app-averages-summary.presenter';
import { GetSelfAppAveragesSummaryQuery } from '../../queries/scores/get-self-app-averages-summary.query';
import { GetSelfAppCalendarEventsAveragesSummaryQuery } from '../../queries/scores/get-self-app-calendar-events-averages-summary.query';

export class GetSelfAppAveragesSummaryCompositeController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly appQuery: GetSelfAppAveragesSummaryQuery,
    protected readonly calendarEventsquery: GetSelfAppCalendarEventsAveragesSummaryQuery,
    protected readonly presenter: GetSelfAppAveragesSummaryPresenter
  ) {}

  async get(
    props: GetSelfAppAveragesSummaryRequestDto
  ): Promise<GetSelfAppAveragesSummaryResponseDto> {
    try {
      const [apps, calendarEvents] = await Promise.all([
        this.appQuery.execute(props),
        this.calendarEventsquery.execute(props),
      ]);
      return this.presenter.toResponse({ apps, calendarEvents });
    } catch (error) {
      throw new Error(
        `GetSelfAppAveragesSummaryCompositeController.get encountered an error ${error}`
      );
    }
  }
}
